// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit_land_submitbtn {
  height: 40px;
  width: 150px;
  border-radius: 10px;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: #007bff;
  color: white;
}

.Addland_form_container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.Addlandh1 {
  text-align: center;
  margin-bottom: 30px;
  font-size: 2rem;
}

.Add_land_form_group {
  margin-bottom: 20px;
}

.Add_land_form_group label {
  display: block;
  font-size: 1rem;
  margin-bottom: 5px;
}

.Add_land_form_group input {
  width: 100%;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #ddd;
  font-size: 1rem;
}

button {
  cursor: pointer;
}

.add_partner_btn {
  display: inline-block;
  background-color: #007bff;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  margin-bottom: 20px;
}

.add_partner_btn:hover {
  background-color: #0056b3;
}

.remove-partner-btn {
  background-color: #f44336;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
}

.remove-partner-btn:hover {
  background-color: #d32f2f;
}

.Add_land_submit_button {
  width: 100%;
  padding: 12px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
}

.Add_land_submit_button:hover {
  background-color: #218838;
}

@media (max-width: 600px) {
  .Addland_form_container {
    padding: 10px;
  }

  .Add_land_form_group {
    margin-bottom: 15px;
  }

  .Add_land_form_group input {
    font-size: 0.9rem;
  }

  .Addlandh1 {
    font-size: 1.5rem;
  }

  .add_partner_btn,
  .Add_land_submit_button {
    font-size: 0.9rem;
  }
}

/* land table  css */

.add_land_search {
  display: flex;
  justify-content: center;
  margin: 20px;
  gap: 40px;
}

.add_land_search input[type="search"] {
  width: 45%;
  padding: 10px;
  font-size: 14px;
  border-radius: 50px;
  outline: none;
  border: none;
  box-shadow: 2px 0 10px #04847e48;
  height: 50px;
}

.add_land_search button {
  color: white;
  border: none;
  cursor: pointer;
  background-color: #eb3d3d;
  height: 50px;
  width: 110px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
}

.landshow_table_wrapper {
  width: 100%;
  overflow-x: auto;
  padding: 10px;
}

.landshow_table_wrapper h1 {
  text-align: center;
  margin-bottom: 20px;
}

/* Table Styles */
.land_show_table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
  overflow-x: auto;
}

.land_show_table th,
.land_show_table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: center;
}

.land_show_table th {
    background-color: #fbe3dc;
    color: #da5a0c;
}

.land_show_table td ul {
  list-style-type: none;
  padding: 0;
}

.mixed_button_add_land {
  display: flex;
  justify-content: space-around;
}

.mixed_button_add_land button {
    padding: 1px 5px;
    margin: 5px;
    border: none;
    cursor: pointer;
}

.land_show_edit_button {
  background-color: #007bff;
  height: 30px;
  width: 60px;
  border-radius: 5px;
  border: none;
  color: rgb(255, 255, 255);
}

.land_show_edit_button:hover {
  background-color: #0056b3;
}

.land_show_delete_button {
  background-color: #dc3545;
  /* Red for Delete */
  height: 30px;
  width: 60px;
  border-radius: 5px;
  border: none;
  color: rgb(255, 255, 255);
}

.land_show_delete_button:hover {
  background-color: #c82333;
}

.land_show_showCard_button {
  background-color: #ffc107;
  /* Yellow for Show */
  height: 30px;
  width: 60px;
  border-radius: 5px;
  border: none;
  color: rgb(255, 255, 255);
}

.land_show_showCard_button:hover {
  background-color: #e0a800;
}

.land_show_start_button {
  background-color: #28a745;
  height: 30px;
  width: 60px;
  border-radius: 5px;
  border: none;
  color: papayawhip;
}

.land_show_start_button:hover {
  background-color: #218838;
}

.land_show_addpatner_payment_button {
  background-color: #17a2b8;
  height: 35px;
  width: 100px;
  border-radius: 5px;
  border: none;
  color: #ffffff;
  font-size: 14px;
}

.land_show_addpatner_payment_button:hover {
  background-color: #138496;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .add_land_search {
    flex-direction: column;
    align-items: center;
    gap: 0px;
  }

  .add_land_search input[type="search"] {
    width: 100%;
    margin-bottom: 10px;
  }

  .land_show_table th,
  .land_show_table td {
    font-size: 14px;
    padding: 8px;
  }

  .mixed_button_add_land {
    flex-direction: column;
    align-items: center;
  }

  .mixed_button_add_land button {
    width: 100%;
    margin-bottom: 10px;
  }
}

@media (max-width: 768px) {
  .land_show_table th,
  .land_show_table td {
    font-size: 12px;
    padding: 6px;
  }

  .land_show_table td ul {
    font-size: 12px;
  }

  .add_land_search input[type="search"] {
    width: 100%;
    margin-bottom: 10px;
  }

  .add_land_search button {
    width: 45%;
    margin-top: 10px;
  }

  .mixed_button_add_land {
    flex-direction: column;
    align-items: center;
  }

  .mixed_button_add_land button {
    width: 100%;
    margin-bottom: 10px;
  }
}

@media (max-width: 480px) {
  .land_show_table th,
  .land_show_table td {
    font-size: 10px;
    padding: 5px;
  }

  .land_show_table td ul {
    font-size: 10px;
  }

  .land_show_table {
    font-size: 12px;
  }

  .add_land_search input[type="search"] {
    width: 100%;
    margin-bottom: 10px;
  }

  .add_land_search button {
    margin-top: 10px;
    width: 120px;
    height: 40px;
  }

  .mixed_button_add_land {
    flex-direction: column;
    align-items: center;
  }

  .mixed_button_add_land button {
    width: 100%;
    margin-bottom: 10px;
    font-size: 12px;
    height: 34px;
    width: 60px;
  }

  .land_show_edit_button {
    height: 40px;
    width: 40px;
    font-size: 12px;
  }

  .land_show_delete_button {
    height: 40px;
    width: 40px;
    font-size: 12px;
  }

  .land_show_showCard_button {
    height: 40px;
    width: 40px;
    font-size: 12px;
  }

  .land_show_addpatner_payment_button {
    height: 40px;
    width: 60px;
    font-size: 12px;
  }
}

/* show card  css */

/* ****************************************** */

.patner_table_main_wrapper {
  overflow-x: auto;
  margin: 10px;
}

.patner_table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.patner_table th,
.patner_table td {
  padding: 10px;
  text-align: left;
  border: 1px solid #ddd;
}

.patner_table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.patner_table_tr:nth-child(even) {
  background-color: #f9f9f9;
}

.patner_table_tr:hover {
  background-color: #f1f1f1;
}

/* Close button styles */
.patner_table_close_button {
  background-color: #f44336;
  color: white;
  border: none;
  padding: 10px 15px;
  font-size: 16px;
  cursor: pointer;
  float: right;
  margin: 10px 10px 10px 0;
}

.patner_table_close_button:hover {
  background-color: #d32f2f;
}

.patner_table_view_button {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  text-align: center;
}

.patner_table_view_button:hover {
  background-color: #45a049;
}

/* Mobile - Small devices */
@media screen and (max-width: 600px) {
  .patner_table {
    font-size: 14px;
  }

  .patner_table th,
  .patner_table td {
    padding: 8px;
  }

  .patner_table_close_button {
    font-size: 14px;
    padding: 8px 12px;
  }

  .patner_table_view_button {
    font-size: 14px;
    padding: 4px 8px;
  }
}

/* Tablet - Medium devices */
@media screen and (min-width: 601px) and (max-width: 1024px) {
  .patner_table {
    font-size: 16px;
  }

  .patner_table th,
  .patner_table td {
    padding: 10px;
  }

  .patner_table_close_button {
    font-size: 16px;
    padding: 10px 15px;
  }

  .patner_table_view_button {
    font-size: 16px;
    padding: 5px 10px;
  }
}

/* Laptop - Large devices */
@media screen and (min-width: 1025px) {
  .patner_table {
    font-size: 18px;
  }

  .patner_table th,
  .patner_table td {
    padding: 12px;
  }

  .patner_table_close_button {
    font-size: 18px;
    padding: 12px 18px;
  }

  .patner_table_view_button {
    font-size: 18px;
    padding: 6px 12px;
  }
}

/*   single patner table */
.singl_patner_table_wrapper {
  overflow-x: auto;
}

.single_patner_card_main_wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 600px;
  background: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  text-align: center;
}

.single_patner_cardclose_button {
  position: absolute;
  top: 10px;
  right: 15px;
  background: red;
  color: white;
  border: none;
  padding: 5px 10px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
}

.single_patner_cardclose_button:hover {
  background: darkred;
}

.single_patner_card_main_wrapper p {
  font-size: 16px;
  margin: 10px 0;
  color: #333;
}

/* Table Styling */
.singl_patner_table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}

.singl_patner_table th,
.singl_patner_table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  font-size: 14px;
}

.singl_patner_table th {
  background-color: #007bff;
  color: white;
  font-weight: bold;
}

.singl_patner_table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .single_patner_card_main_wrapper {
    width: 95%;
    max-width: 100%;
    padding: 15px;
  }

  .singl_patner_table th,
  .singl_patner_table td {
    font-size: 12px;
    padding: 6px;
  }

  .single_patner_cardclose_button {
    font-size: 14px;
    padding: 4px 8px;
  }
}

@media (max-width: 480px) {
  .single_patner_card_main_wrapper {
    width: 95%;
    padding: 10px;
  }

  .singl_patner_table th,
  .singl_patner_table td {
    font-size: 10px;
    padding: 5px;
  }

  .single_patner_cardclose_button {
    font-size: 12px;
    padding: 3px 6px;
  }
}
/*  existing patner payment add */

.existing_patner_form_wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 500px;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

.close_existing_patner_form {
  position: absolute;
  top: 10px;
  right: 15px;
  background: red;
  color: white;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 18px;
  border-radius: 50%;
}

.existing_patner_form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.existing_patner_form input,
.existing_patner_form select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.existing_patner_form_submit_button {
  background: #007bff;
  color: white;
  padding: 12px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  font-size: 16px;
}

.existing_patner_form_submit_button:hover {
  background: #0056b3;
}

/* Overlay Effect */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Responsive */
@media (max-width: 768px) {
  .existing_patner_form_wrapper {
    width: 95%;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .existing_patner_form_wrapper {
    width: 100%;
    border-radius: 0;
  }
}

/* add patner payment */
.add_patner_payment_form_wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: linear-gradient(135deg, #f0f0f0, #ffffff);
  padding: 25px 30px;
  border-radius: 12px;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  max-width: 500px;
  width: 100%;
  overflow-y: auto;
}

.close_patner_payment_form {
  display: flex;
  justify-content: flex-end;
}

.close_patner_payment_form p {
  cursor: pointer;
  font-size: 16px;
  color: #fff;
  height: 35px;
  width: 35px;
  background-color: #ff4d4d;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
}

.close_patner_payment_form p:hover {
  transform: scale(1.1);
}

.add_patner_payment_form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.add_patner_payment_form_input {
  padding: 12px 15px;
  border: 2px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  width: 100%;
  background-color: #fafafa;
  transition: border-color 0.3s;
}

.add_patner_payment_form_input:focus {
  border-color: #007bff;
  outline: none;
}

.add_patner_payment_form_submit_button {
  background: linear-gradient(135deg, #007bff, #0056b3);
  color: #fff;
  padding: 14px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s;
}

.add_patner_payment_form_submit_button:hover {
  background: linear-gradient(135deg, #0056b3, #003f7d);
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .add_patner_payment_form_wrapper {
    padding: 20px;
    max-width: 90%;
  }

  .add_patner_payment_form_input {
    font-size: 13px;
    padding: 10px 12px;
  }

  .add_patner_payment_form_submit_button {
    font-size: 14px;
    padding: 12px;
  }

  .close_patner_payment_form p {
    height: 30px;
    width: 30px;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .add_patner_payment_form_wrapper {
    padding: 15px;
    max-width: 95%;
  }

  .add_patner_payment_form_input {
    font-size: 12px;
    padding: 8px 10px;
  }

  .add_patner_payment_form_submit_button {
    font-size: 12px;
    padding: 10px;
  }

  .close_patner_payment_form p {
    height: 25px;
    width: 25px;
    font-size: 12px;
  }
}

/* patner table css */
.partner-table-container {
  width: 100%;
  overflow-x: auto;
}

.partner-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.partner-table th,
.partner-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: center;
  white-space: nowrap;
}

.partner-table th {
  background-color: #f4f4f4;
  font-weight: bold;
}

.add-payment-btn {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 5px 10px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 5px;
}

.add-payment-btn:hover {
  background-color: #218838;
}

@media (max-width: 768px) {
  .partner-table th,
  .partner-table td {
    font-size: 14px;
    padding: 8px;
  }
}

@media (max-width: 480px) {
  .partner-table th,
  .partner-table td {
    font-size: 12px;
    padding: 6px;
  }
}

/* existing patner add payment form  */
.existing_patner_payment_add_wrapper {
  max-width: 450px;
  width: 90%;
  background: #f9f9f9;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  margin: 30px auto;
  text-align: center;
  position: relative;
  transition: all 0.3s ease-in-out;
  z-index: 2;
  top: -759px;
}

/* Close Button (X) Positioned Above Form */
.existing_patner_close_button {
  display: block;
  background: #ff4d4d;
  color: white;
  border: none;
  padding: 10px 15px;
  font-size: 18px;
  cursor: pointer;
  border-radius: 50px;
  margin: 0 auto 10px;
  transition: 0.3s;
  margin-left: 345px;
}

.existing_patner_close_button:hover {
  background: #d63030;
}

.existing_patner_heading {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.existing_patner_form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.existing_patner_form_input,
.existing_patner_form_select {
  width: 100%;
  padding: 12px;
  border: 2px solid #ddd;
  border-radius: 8px;
  font-size: 16px;
  background: #fff;
  transition: border-color 0.3s;
}

.existing_patner_form_input:focus,
.existing_patner_form_select:focus {
  border-color: #28a745;
  outline: none;
}

/* Submit Button Positioned Below the Form */
.existing_patner_form_button {
  display: block;
  width: 100%;
  background: linear-gradient(135deg, #28a745, #218838);
  color: white;
  border: none;
  padding: 12px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 8px;
  margin-top: 15px;
  transition: 0.3s ease-in-out;
}

.existing_patner_form_button:hover {
  background: linear-gradient(135deg, #218838, #1a6f2f);
}

/* Responsive Design */
@media (max-width: 768px) {
  .existing_patner_payment_add_wrapper {
    width: 90%;
    padding: 20px;
  }

  .existing_patner_form_input,
  .existing_patner_form_select {
    font-size: 14px;
    padding: 10px;
  }

  .existing_patner_form_button {
    font-size: 16px;
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .existing_patner_payment_add_wrapper {
    width: 95%;
    padding: 15px;
  }

  .existing_patner_heading {
    font-size: 20px;
  }

  .existing_patner_form_input,
  .existing_patner_form_select {
    font-size: 12px;
    padding: 8px;
  }

  .existing_patner_form_button {
    font-size: 14px;
    padding: 8px;
  }
}

/* add patner */
.add_patner_form {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  width: 90%;
  max-width: 400px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1000;
}

.close_showAddpatnerForm {
  position: absolute;
  top: 10px;
  right: 10px;
  background: red;
  color: white;
  border: none;
  font-size: 16px;
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 5px;
}

.add_patner_form_input {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.add_patner_form_submit {
  width: 100%;
  padding: 10px;
  background: #007bff;
  color: white;
  border: none;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  margin-top: 10px;
}

.add_patner_form_submit:hover {
  background: #0056b3;
}

.add_patner_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

@media (max-width: 768px) {
  .add_patner_form {
    width: 95%;
  }
}

@media (max-width: 480px) {
  .add_patner_form {
    width: 100%;
    padding: 15px;
  }
}

/* Modal Overlay (Background) */
.editpatnerpayment-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* Modal Content (Popup) */
.editpatnerpayment-content {
  background: white;
  padding: 20px;
  width: 90%;
  max-width: 500px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  text-align: center;
  position: relative;
  animation: fadeIn 0.3s ease-in-out;
}

/* Close Button */
.editpatnerpayment-close {
  position: absolute;
  top: 10px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

/* Form Styling */
.editpatnerpayment-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.editpatnerpayment-input,
.editpatnerpayment-select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.editpatnerpayment-button {
  background: #007bff;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;
}

.editpatnerpayment-button:hover {
  background: #0056b3;
}

/* Responsive Design */
@media (max-width: 768px) {
  .editpatnerpayment-content {
    width: 95%;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .editpatnerpayment-input,
  .editpatnerpayment-select,
  .editpatnerpayment-button {
    font-size: 14px;
    padding: 8px;
  }
  .editpatnerpayment-content {
    max-width: 90%;
  }
}

/* Fade-In Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.handleEditPatnerPayment {
  height: 30px;
  width: 50px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
}
.handledeletePatnerpayment {
  margin-top: 5px;
  height: 30px;
  width: 50px;
  background-color: red;
  color: white;
  border: none;
  border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/addlands/AddLand.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,UAAU;EACV,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,mBAAmB;;AAEnB,+CAA+C;;AAE/C;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,eAAe;IACf,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;AACA,iCAAiC;;AAEjC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,qDAAqD;EACrD,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;IAEE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,YAAY;EACd;AACF;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,4CAA4C;EAC5C,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,UAAU;EACV,WAAW;AACb;;AAEA,2CAA2C;AAC3C;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,cAAc;EACd,WAAW;EACX,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,qDAAqD;AACvD;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA,eAAe;AACf;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,aAAa;EACf;AACF;;AAEA;EACE;;;IAGE,eAAe;IACf,YAAY;EACd;EACA;IACE,cAAc;EAChB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".edit_land_submitbtn {\n  height: 40px;\n  width: 150px;\n  border-radius: 10px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  background-color: #007bff;\n  color: white;\n}\n\n.Addland_form_container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: white;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n}\n\n.Addlandh1 {\n  text-align: center;\n  margin-bottom: 30px;\n  font-size: 2rem;\n}\n\n.Add_land_form_group {\n  margin-bottom: 20px;\n}\n\n.Add_land_form_group label {\n  display: block;\n  font-size: 1rem;\n  margin-bottom: 5px;\n}\n\n.Add_land_form_group input {\n  width: 100%;\n  padding: 12px;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n  font-size: 1rem;\n}\n\nbutton {\n  cursor: pointer;\n}\n\n.add_partner_btn {\n  display: inline-block;\n  background-color: #007bff;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  margin-bottom: 20px;\n}\n\n.add_partner_btn:hover {\n  background-color: #0056b3;\n}\n\n.remove-partner-btn {\n  background-color: #f44336;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 5px;\n}\n\n.remove-partner-btn:hover {\n  background-color: #d32f2f;\n}\n\n.Add_land_submit_button {\n  width: 100%;\n  padding: 12px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  font-size: 1rem;\n}\n\n.Add_land_submit_button:hover {\n  background-color: #218838;\n}\n\n@media (max-width: 600px) {\n  .Addland_form_container {\n    padding: 10px;\n  }\n\n  .Add_land_form_group {\n    margin-bottom: 15px;\n  }\n\n  .Add_land_form_group input {\n    font-size: 0.9rem;\n  }\n\n  .Addlandh1 {\n    font-size: 1.5rem;\n  }\n\n  .add_partner_btn,\n  .Add_land_submit_button {\n    font-size: 0.9rem;\n  }\n}\n\n/* land table  css */\n\n.add_land_search {\n  display: flex;\n  justify-content: center;\n  margin: 20px;\n  gap: 40px;\n}\n\n.add_land_search input[type=\"search\"] {\n  width: 45%;\n  padding: 10px;\n  font-size: 14px;\n  border-radius: 50px;\n  outline: none;\n  border: none;\n  box-shadow: 2px 0 10px #04847e48;\n  height: 50px;\n}\n\n.add_land_search button {\n  color: white;\n  border: none;\n  cursor: pointer;\n  background-color: #eb3d3d;\n  height: 50px;\n  width: 110px;\n  border-radius: 10px;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.landshow_table_wrapper {\n  width: 100%;\n  overflow-x: auto;\n  padding: 10px;\n}\n\n.landshow_table_wrapper h1 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n/* Table Styles */\n.land_show_table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 10px 0;\n  overflow-x: auto;\n}\n\n.land_show_table th,\n.land_show_table td {\n  border: 1px solid #ddd;\n  padding: 12px;\n  text-align: center;\n}\n\n.land_show_table th {\n    background-color: #fbe3dc;\n    color: #da5a0c;\n}\n\n.land_show_table td ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.mixed_button_add_land {\n  display: flex;\n  justify-content: space-around;\n}\n\n.mixed_button_add_land button {\n    padding: 1px 5px;\n    margin: 5px;\n    border: none;\n    cursor: pointer;\n}\n\n.land_show_edit_button {\n  background-color: #007bff;\n  height: 30px;\n  width: 60px;\n  border-radius: 5px;\n  border: none;\n  color: rgb(255, 255, 255);\n}\n\n.land_show_edit_button:hover {\n  background-color: #0056b3;\n}\n\n.land_show_delete_button {\n  background-color: #dc3545;\n  /* Red for Delete */\n  height: 30px;\n  width: 60px;\n  border-radius: 5px;\n  border: none;\n  color: rgb(255, 255, 255);\n}\n\n.land_show_delete_button:hover {\n  background-color: #c82333;\n}\n\n.land_show_showCard_button {\n  background-color: #ffc107;\n  /* Yellow for Show */\n  height: 30px;\n  width: 60px;\n  border-radius: 5px;\n  border: none;\n  color: rgb(255, 255, 255);\n}\n\n.land_show_showCard_button:hover {\n  background-color: #e0a800;\n}\n\n.land_show_start_button {\n  background-color: #28a745;\n  height: 30px;\n  width: 60px;\n  border-radius: 5px;\n  border: none;\n  color: papayawhip;\n}\n\n.land_show_start_button:hover {\n  background-color: #218838;\n}\n\n.land_show_addpatner_payment_button {\n  background-color: #17a2b8;\n  height: 35px;\n  width: 100px;\n  border-radius: 5px;\n  border: none;\n  color: #ffffff;\n  font-size: 14px;\n}\n\n.land_show_addpatner_payment_button:hover {\n  background-color: #138496;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .add_land_search {\n    flex-direction: column;\n    align-items: center;\n    gap: 0px;\n  }\n\n  .add_land_search input[type=\"search\"] {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n\n  .land_show_table th,\n  .land_show_table td {\n    font-size: 14px;\n    padding: 8px;\n  }\n\n  .mixed_button_add_land {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .mixed_button_add_land button {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n}\n\n@media (max-width: 768px) {\n  .land_show_table th,\n  .land_show_table td {\n    font-size: 12px;\n    padding: 6px;\n  }\n\n  .land_show_table td ul {\n    font-size: 12px;\n  }\n\n  .add_land_search input[type=\"search\"] {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n\n  .add_land_search button {\n    width: 45%;\n    margin-top: 10px;\n  }\n\n  .mixed_button_add_land {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .mixed_button_add_land button {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .land_show_table th,\n  .land_show_table td {\n    font-size: 10px;\n    padding: 5px;\n  }\n\n  .land_show_table td ul {\n    font-size: 10px;\n  }\n\n  .land_show_table {\n    font-size: 12px;\n  }\n\n  .add_land_search input[type=\"search\"] {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n\n  .add_land_search button {\n    margin-top: 10px;\n    width: 120px;\n    height: 40px;\n  }\n\n  .mixed_button_add_land {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .mixed_button_add_land button {\n    width: 100%;\n    margin-bottom: 10px;\n    font-size: 12px;\n    height: 34px;\n    width: 60px;\n  }\n\n  .land_show_edit_button {\n    height: 40px;\n    width: 40px;\n    font-size: 12px;\n  }\n\n  .land_show_delete_button {\n    height: 40px;\n    width: 40px;\n    font-size: 12px;\n  }\n\n  .land_show_showCard_button {\n    height: 40px;\n    width: 40px;\n    font-size: 12px;\n  }\n\n  .land_show_addpatner_payment_button {\n    height: 40px;\n    width: 60px;\n    font-size: 12px;\n  }\n}\n\n/* show card  css */\n\n/* ****************************************** */\n\n.patner_table_main_wrapper {\n  overflow-x: auto;\n  margin: 10px;\n}\n\n.patner_table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 20px 0;\n}\n\n.patner_table th,\n.patner_table td {\n  padding: 10px;\n  text-align: left;\n  border: 1px solid #ddd;\n}\n\n.patner_table th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\n.patner_table_tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.patner_table_tr:hover {\n  background-color: #f1f1f1;\n}\n\n/* Close button styles */\n.patner_table_close_button {\n  background-color: #f44336;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  font-size: 16px;\n  cursor: pointer;\n  float: right;\n  margin: 10px 10px 10px 0;\n}\n\n.patner_table_close_button:hover {\n  background-color: #d32f2f;\n}\n\n.patner_table_view_button {\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n  text-align: center;\n}\n\n.patner_table_view_button:hover {\n  background-color: #45a049;\n}\n\n/* Mobile - Small devices */\n@media screen and (max-width: 600px) {\n  .patner_table {\n    font-size: 14px;\n  }\n\n  .patner_table th,\n  .patner_table td {\n    padding: 8px;\n  }\n\n  .patner_table_close_button {\n    font-size: 14px;\n    padding: 8px 12px;\n  }\n\n  .patner_table_view_button {\n    font-size: 14px;\n    padding: 4px 8px;\n  }\n}\n\n/* Tablet - Medium devices */\n@media screen and (min-width: 601px) and (max-width: 1024px) {\n  .patner_table {\n    font-size: 16px;\n  }\n\n  .patner_table th,\n  .patner_table td {\n    padding: 10px;\n  }\n\n  .patner_table_close_button {\n    font-size: 16px;\n    padding: 10px 15px;\n  }\n\n  .patner_table_view_button {\n    font-size: 16px;\n    padding: 5px 10px;\n  }\n}\n\n/* Laptop - Large devices */\n@media screen and (min-width: 1025px) {\n  .patner_table {\n    font-size: 18px;\n  }\n\n  .patner_table th,\n  .patner_table td {\n    padding: 12px;\n  }\n\n  .patner_table_close_button {\n    font-size: 18px;\n    padding: 12px 18px;\n  }\n\n  .patner_table_view_button {\n    font-size: 18px;\n    padding: 6px 12px;\n  }\n}\n\n/*   single patner table */\n.singl_patner_table_wrapper {\n  overflow-x: auto;\n}\n\n.single_patner_card_main_wrapper {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90%;\n  max-width: 600px;\n  background: white;\n  border-radius: 10px;\n  padding: 20px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  z-index: 1000;\n  text-align: center;\n}\n\n.single_patner_cardclose_button {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: red;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.single_patner_cardclose_button:hover {\n  background: darkred;\n}\n\n.single_patner_card_main_wrapper p {\n  font-size: 16px;\n  margin: 10px 0;\n  color: #333;\n}\n\n/* Table Styling */\n.singl_patner_table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 15px;\n}\n\n.singl_patner_table th,\n.singl_patner_table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n  font-size: 14px;\n}\n\n.singl_patner_table th {\n  background-color: #007bff;\n  color: white;\n  font-weight: bold;\n}\n\n.singl_patner_table tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .single_patner_card_main_wrapper {\n    width: 95%;\n    max-width: 100%;\n    padding: 15px;\n  }\n\n  .singl_patner_table th,\n  .singl_patner_table td {\n    font-size: 12px;\n    padding: 6px;\n  }\n\n  .single_patner_cardclose_button {\n    font-size: 14px;\n    padding: 4px 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .single_patner_card_main_wrapper {\n    width: 95%;\n    padding: 10px;\n  }\n\n  .singl_patner_table th,\n  .singl_patner_table td {\n    font-size: 10px;\n    padding: 5px;\n  }\n\n  .single_patner_cardclose_button {\n    font-size: 12px;\n    padding: 3px 6px;\n  }\n}\n/*  existing patner payment add */\n\n.existing_patner_form_wrapper {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90%;\n  max-width: 500px;\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  z-index: 1000;\n}\n\n.close_existing_patner_form {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: red;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n  font-size: 18px;\n  border-radius: 50%;\n}\n\n.existing_patner_form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.existing_patner_form input,\n.existing_patner_form select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.existing_patner_form_submit_button {\n  background: #007bff;\n  color: white;\n  padding: 12px;\n  border: none;\n  cursor: pointer;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.existing_patner_form_submit_button:hover {\n  background: #0056b3;\n}\n\n/* Overlay Effect */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .existing_patner_form_wrapper {\n    width: 95%;\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .existing_patner_form_wrapper {\n    width: 100%;\n    border-radius: 0;\n  }\n}\n\n/* add patner payment */\n.add_patner_payment_form_wrapper {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: linear-gradient(135deg, #f0f0f0, #ffffff);\n  padding: 25px 30px;\n  border-radius: 12px;\n  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.15);\n  z-index: 9999;\n  max-width: 500px;\n  width: 100%;\n  overflow-y: auto;\n}\n\n.close_patner_payment_form {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.close_patner_payment_form p {\n  cursor: pointer;\n  font-size: 16px;\n  color: #fff;\n  height: 35px;\n  width: 35px;\n  background-color: #ff4d4d;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s ease;\n}\n\n.close_patner_payment_form p:hover {\n  transform: scale(1.1);\n}\n\n.add_patner_payment_form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.add_patner_payment_form_input {\n  padding: 12px 15px;\n  border: 2px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  width: 100%;\n  background-color: #fafafa;\n  transition: border-color 0.3s;\n}\n\n.add_patner_payment_form_input:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.add_patner_payment_form_submit_button {\n  background: linear-gradient(135deg, #007bff, #0056b3);\n  color: #fff;\n  padding: 14px;\n  font-size: 16px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.3s ease, transform 0.2s;\n}\n\n.add_patner_payment_form_submit_button:hover {\n  background: linear-gradient(135deg, #0056b3, #003f7d);\n  transform: translateY(-2px);\n}\n\n@media (max-width: 768px) {\n  .add_patner_payment_form_wrapper {\n    padding: 20px;\n    max-width: 90%;\n  }\n\n  .add_patner_payment_form_input {\n    font-size: 13px;\n    padding: 10px 12px;\n  }\n\n  .add_patner_payment_form_submit_button {\n    font-size: 14px;\n    padding: 12px;\n  }\n\n  .close_patner_payment_form p {\n    height: 30px;\n    width: 30px;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .add_patner_payment_form_wrapper {\n    padding: 15px;\n    max-width: 95%;\n  }\n\n  .add_patner_payment_form_input {\n    font-size: 12px;\n    padding: 8px 10px;\n  }\n\n  .add_patner_payment_form_submit_button {\n    font-size: 12px;\n    padding: 10px;\n  }\n\n  .close_patner_payment_form p {\n    height: 25px;\n    width: 25px;\n    font-size: 12px;\n  }\n}\n\n/* patner table css */\n.partner-table-container {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.partner-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n}\n\n.partner-table th,\n.partner-table td {\n  border: 1px solid #ddd;\n  padding: 10px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.partner-table th {\n  background-color: #f4f4f4;\n  font-weight: bold;\n}\n\n.add-payment-btn {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  font-size: 14px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.add-payment-btn:hover {\n  background-color: #218838;\n}\n\n@media (max-width: 768px) {\n  .partner-table th,\n  .partner-table td {\n    font-size: 14px;\n    padding: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .partner-table th,\n  .partner-table td {\n    font-size: 12px;\n    padding: 6px;\n  }\n}\n\n/* existing patner add payment form  */\n.existing_patner_payment_add_wrapper {\n  max-width: 450px;\n  width: 90%;\n  background: #f9f9f9;\n  padding: 25px;\n  border-radius: 12px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);\n  margin: 30px auto;\n  text-align: center;\n  position: relative;\n  transition: all 0.3s ease-in-out;\n  z-index: 2;\n  top: -759px;\n}\n\n/* Close Button (X) Positioned Above Form */\n.existing_patner_close_button {\n  display: block;\n  background: #ff4d4d;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  font-size: 18px;\n  cursor: pointer;\n  border-radius: 50px;\n  margin: 0 auto 10px;\n  transition: 0.3s;\n  margin-left: 345px;\n}\n\n.existing_patner_close_button:hover {\n  background: #d63030;\n}\n\n.existing_patner_heading {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.existing_patner_form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.existing_patner_form_input,\n.existing_patner_form_select {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #ddd;\n  border-radius: 8px;\n  font-size: 16px;\n  background: #fff;\n  transition: border-color 0.3s;\n}\n\n.existing_patner_form_input:focus,\n.existing_patner_form_select:focus {\n  border-color: #28a745;\n  outline: none;\n}\n\n/* Submit Button Positioned Below the Form */\n.existing_patner_form_button {\n  display: block;\n  width: 100%;\n  background: linear-gradient(135deg, #28a745, #218838);\n  color: white;\n  border: none;\n  padding: 12px;\n  font-size: 18px;\n  font-weight: bold;\n  cursor: pointer;\n  border-radius: 8px;\n  margin-top: 15px;\n  transition: 0.3s ease-in-out;\n}\n\n.existing_patner_form_button:hover {\n  background: linear-gradient(135deg, #218838, #1a6f2f);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .existing_patner_payment_add_wrapper {\n    width: 90%;\n    padding: 20px;\n  }\n\n  .existing_patner_form_input,\n  .existing_patner_form_select {\n    font-size: 14px;\n    padding: 10px;\n  }\n\n  .existing_patner_form_button {\n    font-size: 16px;\n    padding: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .existing_patner_payment_add_wrapper {\n    width: 95%;\n    padding: 15px;\n  }\n\n  .existing_patner_heading {\n    font-size: 20px;\n  }\n\n  .existing_patner_form_input,\n  .existing_patner_form_select {\n    font-size: 12px;\n    padding: 8px;\n  }\n\n  .existing_patner_form_button {\n    font-size: 14px;\n    padding: 8px;\n  }\n}\n\n/* add patner */\n.add_patner_form {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  padding: 20px;\n  width: 90%;\n  max-width: 400px;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  z-index: 1000;\n}\n\n.close_showAddpatnerForm {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: red;\n  color: white;\n  border: none;\n  font-size: 16px;\n  padding: 5px 10px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.add_patner_form_input {\n  width: 100%;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.add_patner_form_submit {\n  width: 100%;\n  padding: 10px;\n  background: #007bff;\n  color: white;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 5px;\n  margin-top: 10px;\n}\n\n.add_patner_form_submit:hover {\n  background: #0056b3;\n}\n\n.add_patner_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n@media (max-width: 768px) {\n  .add_patner_form {\n    width: 95%;\n  }\n}\n\n@media (max-width: 480px) {\n  .add_patner_form {\n    width: 100%;\n    padding: 15px;\n  }\n}\n\n/* Modal Overlay (Background) */\n.editpatnerpayment-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n/* Modal Content (Popup) */\n.editpatnerpayment-content {\n  background: white;\n  padding: 20px;\n  width: 90%;\n  max-width: 500px;\n  border-radius: 8px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  position: relative;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n/* Close Button */\n.editpatnerpayment-close {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: transparent;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n/* Form Styling */\n.editpatnerpayment-form {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.editpatnerpayment-input,\n.editpatnerpayment-select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.editpatnerpayment-button {\n  background: #007bff;\n  color: white;\n  padding: 10px;\n  border: none;\n  border-radius: 5px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.editpatnerpayment-button:hover {\n  background: #0056b3;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .editpatnerpayment-content {\n    width: 95%;\n    padding: 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .editpatnerpayment-input,\n  .editpatnerpayment-select,\n  .editpatnerpayment-button {\n    font-size: 14px;\n    padding: 8px;\n  }\n  .editpatnerpayment-content {\n    max-width: 90%;\n  }\n}\n\n/* Fade-In Animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.handleEditPatnerPayment {\n  height: 30px;\n  width: 50px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n}\n.handledeletePatnerpayment {\n  margin-top: 5px;\n  height: 30px;\n  width: 50px;\n  background-color: red;\n  color: white;\n  border: none;\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
